import {
  isHttpError,
  type HttpError,
} from '@breezeventures/web-lib-ph-request/errors';

import type { OrderParams } from '../product';

const productValidationErrors = ['SUM_TOO_LOW', 'SUM_TOO_HIGH'] as const;
export type ProductValidationErrorCode =
  (typeof productValidationErrors)[number];

export type ProductValidationError = HttpError &
  OrderParams & {
    code: ProductValidationErrorCode;
  };

export function isProductValidationError(
  error: Error
): error is ProductValidationError {
  return (
    isHttpError(error) &&
    'code' in error &&
    typeof error.code === 'string' &&
    (productValidationErrors as readonly string[]).includes(error.code)
  );
}
